import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin } from "lucide-react";
import { Wordmark } from "@/components/Navbar";

const CERTS = ["AGMARK", "FSSAI", "ISO 22000", "APEDA"];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-cream/10 bg-night pb-10 pt-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <Wordmark dark />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-cream/55">
              Export-grade finger turmeric, Sannam red chillies and 100% cold pressed oils —
              from Indian farm belts to global markets.
            </p>
            <div className="mt-6 flex gap-3">
              {[
                { icon: Facebook, label: "Facebook" },
                { icon: Instagram, label: "Instagram" },
                { icon: Linkedin, label: "LinkedIn" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#top"
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  aria-label={s.label}
                  onClick={(e) => e.preventDefault()}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/15 text-cream/60 transition-all duration-300 hover:border-amberwarm hover:text-amberwarm"
                >
                  <s.icon size={16} />
                </a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.22em] text-amberwarm">Explore</h4>
            <ul className="mt-5 space-y-3 text-sm text-cream/65">
              {[
                ["Spices", "#products"],
                ["Cold Pressed Oils", "#oils"],
                ["About Us", "#about"],
                ["Get a Quote", "#quote"],
              ].map(([label, href]) => (
                <li key={label}>
                  <a
                    href={href}
                    data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="transition-colors hover:text-amberwarm"
                  >
                    {label}
                  </a>
                </li>
              ))}
              <li>
                <Link to="/oil-story" data-testid="footer-link-oil-story" className="transition-colors hover:text-amberwarm">
                  Oil Story
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-mono text-xs uppercase tracking-[0.22em] text-amberwarm">Certifications</h4>
            <div className="mt-5 flex flex-wrap gap-2">
              {CERTS.map((c) => (
                <span key={c} className="rounded-full border border-cream/15 px-4 py-1.5 text-xs font-medium text-cream/70">
                  {c}
                </span>
              ))}
            </div>
            <p className="mt-6 text-xs leading-relaxed text-cream/45">
              302, 3rd Floor, Flydesk, #901, Ayyappa Society Main Rd,
              <br />SBH Officers Colony, Mega Hills, Madhapur,
              <br />Hyderabad, Telangana 500081
              <br />info@tsugivainternational.com
            </p>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-cream/10 pt-7 text-xs text-cream/40 sm:flex-row">
          <span>© {new Date().getFullYear()} Tsugiva International Traders. All rights reserved.</span>
          <Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-amberwarm">
            Admin Portal
          </Link>
        </div>
      </div>
    </footer>
  );
}
